import { useListContext } from 'react-admin';
import { FormProvider } from 'react-hook-form';
import { FilterBar, FilterBarActions, FilterBarRow } from 'shared/mui/Filter/FilterBar';
import { FilterApplyButton, FilterResetButton } from 'shared/mui/Filter/FilterButtons';
import { useFilters } from 'shared/mui/Filter/hooks/useFilters';
import { useSyncFilter } from 'shared/mui/Filter/hooks/useSyncFilter';
import { TextInput } from 'shared/react-admin/Inputs';

type RolesListFilterValues = {
  name: string;
};

const DEFAULT_VALUES: RolesListFilterValues = { name: '' };

export const RolesListFilter: React.FC = () => {
  const { filterValues } = useListContext();
  const { form, onReset, onSubmit, appliedFilters } = useFilters<RolesListFilterValues>({
    defaultValues: { ...DEFAULT_VALUES, ...filterValues },
    resetValues: DEFAULT_VALUES,
  });

  useSyncFilter<RolesListFilterValues>({ appliedFilters });

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <FilterBar>
          <FilterBarRow sx={{ gridTemplateColumns: '1fr auto' }}>
            <TextInput
              helperText={false}
              label="Название"
              name="name"
              source="name"
              variant="outlined"
            />
            <FilterBarActions>
              <FilterResetButton onReset={onReset} />
              <FilterApplyButton type="submit" />
            </FilterBarActions>
          </FilterBarRow>
        </FilterBar>
      </form>
    </FormProvider>
  );
};
